import createAsyncAction from "../../utils/asyncAction";
import * as api from "../api/stickers/stickers_api";
import * as types from "../constants/stickers_constants";
import toast from "react-hot-toast";

const getUserStickersTypes = {
  success: types.GET_USER_STIKER_SUCCESS,
  failure: types.GET_USER_STIKER_FAILURE,
};

const singleStickersTypes = {
  success: types.SINGLE_STICKER_SUCCESS,
  failure: types.SINGLE_STICKER_FAILURE,
};

const updateUserStickersTypes = {
  success: types.UPDATE_STICKER_SUCCESS,
  failure: types.UPDATE_STICKER_FAILURE,
};

const uploadFileAction =
  (fileType, id, formData, successType, failureType) => async (dispatch) => {
    try {
      const response = await api[`upload${fileType}`](id, formData);
      const { error, data } = response;

      if (error) {
        dispatch({ type: failureType, payload: error });
      } else {
        dispatch({ type: successType, payload: data });
      }
    } catch (error) {
      dispatch({
        type: failureType,
        payload: error,
      });
    }
  };

export const getUserStickers = createAsyncAction(
  api.getUserStickers,
  getUserStickersTypes
);

export const updateUserSticker = createAsyncAction(
  api.updateUserSticker,
  updateUserStickersTypes
);

export const singleSticker = createAsyncAction(
  api.singleSticker,
  singleStickersTypes
);

export const uploadRegFile = (id, formData) =>
  uploadFileAction(
    "RegDoc",
    id,
    formData,
    types.UPLOAD_REG_STICKER_SUCCESS,
    types.UPLOAD_REG_STICKER_FAILURE
  );

export const uploadSupportFile = (id, formData) =>
  uploadFileAction(
    "SupportDoc",
    id,
    formData,
    types.UPLOAD_SUPPORT_STICKER_SUCCESS,
    types.UPLOAD_SUPPORT_STICKER_FAILURE
  );

const getReplacementStickerId = (data) => {
  return (
    data?.sticker?.id ||
    data?.replacementSticker?.id ||
    data?.replacement_sticker?.id ||
    data?.replacement?.id ||
    data?.id
  );
};

const getStickerReceiptUrl = (data) => {
  const sticker = data?.sticker || data?.replacementSticker || data;

  return (
    sticker?.receipt?.url ||
    sticker?.new_receipt?.url ||
    sticker?.receipts?.find((receipt) => receipt?.url)?.url ||
    data?.receipt?.url
  );
};

export const replaceUserSticker =
  (id, values, replacementFile) => async (dispatch) => {
    try {
      const response = await api.replaceSticker(id, values);
      const { error, data } = response;

      if (error) {
        toast.error(error);
        dispatch({ type: types.REPLACE_STICKER_FAILURE, payload: error });
        return { error, data: null };
      }

      dispatch({ type: types.REPLACE_STICKER_SUCCESS, payload: data });

      const replacementStickerId = getReplacementStickerId(data);

      if (!replacementStickerId) {
        const message = "Replacement sticker could not be created.";
        toast.error(message);
        dispatch({
          type: types.REPLACE_STICKER_FAILURE,
          payload: message,
        });
        return { error: message, data: null };
      }

      const uploadData = new FormData();
      uploadData.append("file", replacementFile);

      const uploadResponse = await api.uploadReplacementFile(
        replacementStickerId,
        uploadData
      );

      if (uploadResponse.error) {
        toast.error(uploadResponse.error);
        dispatch({
          type: types.UPLOAD_REPLACEMENT_STICKER_FAILURE,
          payload: uploadResponse.error,
        });
        return { error: uploadResponse.error, data: null };
      }

      dispatch({
        type: types.UPLOAD_REPLACEMENT_STICKER_SUCCESS,
        payload: uploadResponse.data,
      });

      const paymentResponse =
        await api.replacementStickerPayment(replacementStickerId);

      if (paymentResponse.error) {
        toast.error(paymentResponse.error);
        dispatch({
          type: types.REPLACEMENT_STICKER_PAYMENT_FAILURE,
          payload: paymentResponse.error,
        });
        return { error: paymentResponse.error, data: null };
      }

      dispatch({
        type: types.REPLACEMENT_STICKER_PAYMENT_SUCCESS,
        payload: paymentResponse.data,
      });

      const receiptUrl = getStickerReceiptUrl(paymentResponse.data);

      if (receiptUrl) {
        window.location.href = receiptUrl;
        return { error: null, data: paymentResponse.data };
      }

      const message = "Payment link could not be generated. Please try again.";
      toast.error(message);
      dispatch({
        type: types.REPLACEMENT_STICKER_PAYMENT_FAILURE,
        payload: message,
      });
      return { error: message, data: null };
    } catch (error) {
      const message = "No Connection";
      toast.error(message);
      dispatch({
        type: types.REPLACE_STICKER_FAILURE,
        payload: message,
      });
      return { error: message, data: null };
    }
  };

export const applyUserSticker =
  (formData, navigate, routePrefix = "/home") =>
  async (dispatch) => {
    try {
      const response = await api.applyUserSticker(formData);
      const { error, data } = response;

      if (error) {
        dispatch({ type: types.APPLY_STICKER_FAILURE, payload: error });
      } else {
        const { sticker } = data;
        dispatch({ type: types.APPLY_STICKER_SUCCESS, payload: sticker });
        navigate(`${routePrefix}/stickers/upload/${sticker.id}`);
      }
    } catch (error) {
      dispatch({
        type: types.APPLY_STICKER_FAILURE,
        payload: "No Connection",
      });
    }
  };
